import { render } from "./RakutenAdvertisingLogoIcon.vue?vue&type=template&id=5080f81a"
import script from "./RakutenAdvertisingLogoIcon.vue?vue&type=script&lang=js"
export * from "./RakutenAdvertisingLogoIcon.vue?vue&type=script&lang=js"

import "./RakutenAdvertisingLogoIcon.vue?vue&type=style&index=0&id=5080f81a&lang=scss"

import exportComponent from "/home/runner/work/flydata-next/flydata-next/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__